<div class="dialog-wrapper more-info">
  <header class="dialog__header">
    <h1 mat-dialog-tittle>{{ 'moreInfo.manageFloorsElevators' | xTranslate }}</h1>
    <mat-icon class="dialog-close" mat-dialog-close>close</mat-icon>
  </header>
  <div class="dialog__contents" mat-dialog-content>
    <mat-tab-group class="tab-custom">
      <mat-tab label="{{ 'moreInfo.floors' | xTranslate }}">
        <ng-template matTabContent>
          <div class="tab-content">
            <sp-floors
              [elevatorSelectedFloors]="elevatorSelectedFloors"
              [floorData]="floorData"
              [floorsHeaderData]="floorsHeaderData"
              [localeId]="localeId"
              (updateFloorData)="updatedFloorData($event)"
            ></sp-floors>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="{{ 'moreInfo.elevators' | xTranslate }}">
        <ng-template matTabContent>
          <div class="tab-content">
            <sp-elevators
              [elevatorInfo]="elevatorInfo"
              [floorData]="floorData"
              (updateElevatorData)="updateElevatorData($event)"
            ></sp-elevators>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
